import React, { useState } from "react";
import SecondaryButton from "../../components/Common/Buttons/SecondaryButton";
import Tipping from "./Tipping";
import IconTwitter from "../../../images/icons/icon_twitter.png";
import IconLine from "../../../images/icons/icon_line.png";
import IconFacebook from "../../../images/icons/icon_facebook.png";
import URLCopyModal from "./URLCopyModal";
import QRCodeModal from "./QRCodeModal";
import WidgetModal from "./WidgetModal";
import { projectStatusCodes } from "../../utils/constants";
import FundingSummary from "./FundingSummary";

type Props = {
  investmentID: number;
  investmentProgressingSum: number;
  pendingAmount: number;
  targetAmount: number;
  nextTargetAmount?: number;
  supportCount: number;
  supporterCount: number;
  isProjectActive: boolean;
  remainingPeriod: number;
  beginDateTime: string;
  endDateTime: string;
  beginDate: string;
  endDate: string;
  paymentDueDate: string;
  showPaymentDueDate: boolean;
  referralURL: string;
  widgetURL: string;
  investmentTitle: string;
  projectStatusCode: number;
  canTip: boolean;
  isLoggedIn: boolean;
  cardRegistered: boolean;
  accountEmail: string;
  payJpPublicKey: string;
  moveToReferral?: () => void | null;
  fundingSummaryBannerUrl?: string;
  tippingAmounts?: number[];
};

const Progress: React.FC<Props> = (props) => {
  const {
    investmentProgressingSum = 0,
    targetAmount = 0,
    pendingAmount = 0,
    nextTargetAmount,
    supportCount,
    supporterCount,
    isProjectActive,
    remainingPeriod,
    beginDateTime,
    endDateTime,
    beginDate,
    endDate,
    paymentDueDate,
    showPaymentDueDate,
    referralURL,
    widgetURL,
    investmentTitle,
    projectStatusCode,
    canTip,
    isLoggedIn,
    cardRegistered,
    accountEmail,
    payJpPublicKey,
    moveToReferral,
    fundingSummaryBannerUrl,
    tippingAmounts,
  } = props;

  const [isURLCopyModalActive, setIsURLCopyModalActive] = useState<boolean>(false)
  const [isQRCodeModalActive, setIsQRCodeModalActive] = useState<boolean>(false)
  const [isWidgetModalActive, setIsWidgetModalActive] = useState<boolean>(false)
  const [investmentTotalAmount, setInvestmentTotalAmount] = useState<number>(investmentProgressingSum);

  const toggleURLCopyModal = () => {
    setIsURLCopyModalActive(!isURLCopyModalActive)
  }

  const toggleQRCodeModal = () => {
    setIsQRCodeModalActive(!isQRCodeModalActive)
  }

  const openURLCopyModal = () => {
    toggleURLCopyModal()
    navigator.clipboard.writeText(referralURL)
  }

  const toggleWidgetModal = () => {
    setIsWidgetModalActive(!isWidgetModalActive)
  }

  return (
    <>
      <div className="border-[#D2DFE6] sm:w-[360px] border-b border-t">
        <div className="py-[30px] sm:pt-[50px] sm:pb-5">
          {fundingSummaryBannerUrl ? (
            <img
              src={fundingSummaryBannerUrl}
              alt="プロジェクト企画バナー"
              className="block h-auto w-full"
            />
          ) : (
            <FundingSummary
              investmentTotalAmount={investmentTotalAmount}
              targetAmount={targetAmount}
              pendingAmount={pendingAmount}
              nextTargetAmount={nextTargetAmount}
              projectStatusCode={projectStatusCode}
              paymentDueDate={paymentDueDate}
              showPaymentDueDate={showPaymentDueDate}
            />
          )}
          <div className="mt-3">
            { canTip && (
              <Tipping
                projectID={props.investmentID}
                setInvestmentTotalAmount={setInvestmentTotalAmount}
                canTip={canTip}
                isLoggedIn={isLoggedIn}
                cardRegistered={cardRegistered}
                accountEmail={accountEmail}
                payJpPublicKey={payJpPublicKey}
                tippingAmounts={tippingAmounts}
              />
            )}
          </div>
          <div className="mt-4">
            <dl className="flex justify-between mb-1">
              <dt className="text-[#768084] text-sm left-icon icon-human flex items-center">支援者数</dt>
              <dd>{supporterCount.toLocaleString()}人</dd>
            </dl>
            <dl className="flex justify-between mb-1">
              <dt className="text-[#768084] text-sm left-icon icon-human flex items-center">支援数</dt>
              <dd>{supportCount.toLocaleString()}件</dd>
            </dl>
            <dl className="flex justify-between">
              <dt className="text-sm text-[#768084] left-icon icon-clock-grey flex items-center">残り時間</dt>
              {isProjectActive ? (
                remainingPeriod === 0 ? (
                  <dd className="text-red-500">本日最終日({endDateTime.split(' ').pop()}終了)</dd>
                ) : (
                  <dd>{remainingPeriod}日({endDateTime}終了)</dd>
                )
              ) : (
                projectStatusCode === projectStatusCodes.PROJECT_STATUS_COMING_SOON ? (
                  <dd>{beginDateTime}開始</dd>
                ): (
                  <dd>募集は終了しました</dd>
                )
              )}
            </dl>
            {projectStatusCode === projectStatusCodes.PROJECT_STATUS_END && (
              <dl className="flex justify-between">
                <dt className="text-sm text-[#768084] left-icon icon-calender flex items-center">募集期間</dt>
                <dd>{beginDate}〜{endDate}</dd>
              </dl>
            )}
          </div>
        </div>
        <div className="py-[30px] border-[#D2DFE6] border-t sm:py-5">
          <div className="flex items-center justify-center text-center text-sm font-bold">
            {moveToReferral ? (
              <button onClick={moveToReferral}>このプロジェクトを紹介してプレゼントをGET!</button>
            ) : (
              "このプロジェクトを紹介してプレゼントをGET!"
            )}
          </div>
          <div className="sm:flex sm:items-center">
            <ul className="my-[15px] flex items-center justify-center sm:mr-5">
              <li className="w-[25px] h-[25px] mr-5">
                <a href={`http://www.facebook.com/share.php?quote=${investmentTitle}&u=${referralURL}`} className="link-hover-none inline-block">
                  <img src={IconFacebook} alt="facebook" />
                </a>
              </li>
              <li className="w-[24px] h-[25px] mr-5">
                <a href={`http://twitter.com/share?url="${referralURL}"&text=${investmentTitle}`} className="link-hover-none inline-block">
                  <img src={IconTwitter} alt="twitter" />
                </a>
              </li>
              <li className="w-[25px] h-[25px]">
                <a href={`https://social-plugins.line.me/lineit/share?url=${referralURL}`} className="link-hover-none inline-block">
                  <img src={IconLine} alt="line" />
                </a>
              </li>
            </ul>
            <div className="flex justify-center">
              <div className="mr-1 w-[80px] h-[25px] sm:w-[70px]">
                <SecondaryButton
                  text="URLコピー"
                  iconLeft="icon-copy"
                  fontSize="text-xxs"
                  onClick={openURLCopyModal}
                />
              </div>
              <div className="mr-1 w-[80px] h-[25px] sm:w-[70px]">
                <SecondaryButton
                  text="QRコード"
                  iconLeft="icon-qr"
                  fontSize="text-xxs"
                  onClick={toggleQRCodeModal}
                />
              </div>
              <div className="mr-1 w-[80px] h-[25px] sm:w-[70px]">
                <SecondaryButton
                  text="埋め込み"
                  iconLeft="icon-tag"
                  fontSize="text-xxs"
                  onClick={toggleWidgetModal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <URLCopyModal
        isActive={isURLCopyModalActive}
        toggleModal={toggleURLCopyModal}
      />
      <QRCodeModal
        isActive={isQRCodeModalActive}
        toggleModal={toggleQRCodeModal}
        referralURL={referralURL}
      />
      <WidgetModal
        isActive={isWidgetModalActive}
        toggleModal={toggleWidgetModal}
        widgetURL={widgetURL}
      />
    </>
  );
};

export default Progress;
